export default __webpack_public_path__ + "static/logo-e-1-9a64fd241bebf3217275fe999f17dd94.png";